import React from 'react'
import { relativeTime, formatTimestamp } from '@/lib/dates'

interface TimestampLabelProps {
  iso: string
  mode?: 'relative' | 'absolute' | 'both'
  prefix?: string
  className?: string
}

export function TimestampLabel({
  iso,
  mode = 'both',
  prefix,
  className = '',
}: TimestampLabelProps) {
  const relative = relativeTime(iso)
  const absolute = formatTimestamp(iso)

  return (
    <span
      className={`text-tiny text-text-dim tabular-nums ${className}`}
      title={absolute}
    >
      {prefix && <span>{prefix} </span>}
      {mode === 'relative' && relative}
      {mode === 'absolute' && absolute}
      {mode === 'both' && `${relative} (${absolute})`}
    </span>
  )
}
